import { render, staticRenderFns } from "./reject.vue?vue&type=template&id=420d6248&scoped=true&"
import script from "./reject.vue?vue&type=script&lang=js&"
export * from "./reject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420d6248",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('420d6248')) {
      api.createRecord('420d6248', component.options)
    } else {
      api.reload('420d6248', component.options)
    }
    module.hot.accept("./reject.vue?vue&type=template&id=420d6248&scoped=true&", function () {
      api.rerender('420d6248', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/captains_registration_requests/actions/reject.vue"
export default component.exports